import { render } from "./ErrorAlert.vue?vue&type=template&id=08262253&ts=true"
import script from "./ErrorAlert.vue?vue&type=script&lang=ts"
export * from "./ErrorAlert.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Users\\temari\\WebstormProjects\\iidx_viewer\\vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__